import { css } from 'styled-system/css';
import { Cell } from './Cell';
import { RowGutter } from './RowGutter';
import { colAlign, rowValues, type SheetRow } from './sheetData';

export function DataRow({
  index,
  row,
  wide,
  soft,
  selected,
  selectedCol,
  proposal,
  commented,
}: {
  index: number;
  row: SheetRow;
  wide?: boolean;
  soft?: boolean;
  selected: boolean;
  selectedCol?: number;
  proposal?: { startCol: number; endCol: number };
  commented?: boolean;
}) {
  const values = rowValues(row, wide);
  return (
    <div
      data-selected={selected || undefined}
      data-wide={wide || undefined}
      className={css({
        display: 'grid',
        gridTemplateColumns:
          '36px minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 1fr)',
        borderBottom: '1px solid token(colors.border.hairline)',
        color: 'text.secondary',
        '&[data-wide]': {
          gridTemplateColumns: '47px repeat(7, 64px)',
        },
        '&[data-selected]': {
          outline: '1px solid token(colors.prism.violet)',
          outlineOffset: '-1px',
          background: 'rgba(139, 92, 246, 0.08)',
        },
      })}
    >
      <RowGutter n={index} active={selectedCol !== undefined} soft={soft} />
      {values.map((value, c) => (
        <Cell
          key={c}
          align={colAlign(c)}
          commented={commented && c === 0}
          selected={selectedCol === c}
          proposal={
            proposal != null && c >= proposal.startCol && c <= proposal.endCol
          }
        >
          {value}
        </Cell>
      ))}
    </div>
  );
}
